import $ from 'jquery';
import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';
import Autoplay from 'swiper/modules/autoplay.min.mjs';
import EffectFade from 'swiper/modules/effect-fade.mjs';

 
const slider = new Swiper('.slider', {
    modules: [Autoplay,Navigation,EffectFade],
    speed: 1200,
    spaceBetween: 15,
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    autoplay: {
        delay: 8000,
        disableOnInteraction: true, 
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
  });
const tesl__slider = new Swiper('.tesl__slider', {
    modules: [Autoplay,Pagination],
    speed: 1200,
    spaceBetween: 15,
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 8000,
        disableOnInteraction: true, 
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, 
    },
  });

  // const review__box = new Swiper('.review__box', {
  //   modules: [Autoplay,Pagination],
  //   speed: 800,
  //   spaceBetween: 15,
  //   loop: false,
  //   slidesPerView: 1,
  //   autoplay: {
  //       delay: 8000,
  //       disableOnInteraction: true,
  //   },
  //   pagination: {
  //     el: '.swiper-pagination__review',
  //     clickable: true, 
  //   },
  // });
  
  const ds__slider = new Swiper(".ds__slider", {
    modules: [Autoplay,Navigation],
    loop: false,
    speed: 600,
    slidesPerView:1,
    spaceBetween: 10,
    autoplay: {
        delay: 5050,
        disableOnInteraction: false,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
        '720': {
          slidesPerView: 2.2,
        },
        '1100': {
          slidesPerView: 2.8,
        },
      }
});




